'use client'

import { useRef } from 'react'
import { cn } from '@/lib/utils'

// Wraps the hero: the graph paper lights up in signal teal around the pointer.
// Pointer-driven only (nothing moves on its own), so it stays on for reduced motion.
export function HeroSpotlight({ className, children, ...props }) {
  const ref = useRef(null)

  const onPointerMove = event => {
    if (event.pointerType !== 'mouse' || !ref.current) return
    const box = ref.current.getBoundingClientRect()
    ref.current.style.setProperty('--mx', `${event.clientX - box.left}px`)
    ref.current.style.setProperty('--my', `${event.clientY - box.top}px`)
  }

  return (
    <section
      ref={ref}
      onPointerMove={onPointerMove}
      className={cn('group relative isolate', className)}
      {...props}
    >
      <div
        aria-hidden
        className="grid-glow pointer-events-none absolute inset-0 -z-10 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
      />
      {children}
    </section>
  )
}
